import { Toast, ToastType } from 'features/ToastManager/types'

export const actions = {
  addToast: (toast: Omit<Toast, 'id'>) => ({ type: 'TOAST__ADD_TOAST', toast } as const),
  removeToast: (id: string, toastType: ToastType) => ({ type: 'TOAST__REMOVE_TOAST', id, toastType } as const)
}
